module.exports = __webpack_public_path__ + "static/img/Cardfooter05.4af0f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter05.png
// module id = vffW
// module chunks = 1